import React from "react";

import {
  HelperText,
  IconStyles,
  TextAreaWrapper,
  Label,
  StyledTextArea,
  Wrapper
} from "components/Input/styled";

const Textarea = ({
  id,
  label,
  size = "M",
  value,
  onChange,
  placeholder,
  rows = 4,
  error,
  className,
  leftIcon,
  disabled,
  rightIcon,
  ...props
}) => {
  return (
    <Wrapper size={size} className={className}>
      {label && (
        <Label htmlFor={id} size={size}>
          {label}
          {props.required && <span className="required">*</span>}
        </Label>
      )}

      <TextAreaWrapper size={size} disabled={disabled}>
        {leftIcon && (
          <IconStyles size={size} className="left-icon">
            {leftIcon}
          </IconStyles>
        )}

        <StyledTextArea
          id={id}
          size={size}
          disabled={disabled}
          name={id}
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          className={error ? "error" : ""}
          {...props}
        />

        {rightIcon && (
          <IconStyles size={size} className="right-icon">
            {rightIcon}
          </IconStyles>
        )}
      </TextAreaWrapper>

      {error && <HelperText>{error}</HelperText>}
    </Wrapper>
  );
};

export default Textarea;
